// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/Confirm/ConfirmHeader/ConfirmHeader.less
// module id = 821
// module chunks = 0